import React from "react";
import { Text } from "@showitinc/showit-wc";
import ShowitNameLogo from "./ShowitNameLogo";
import MessageUtils from "../utils/MessageUtils";
import styles from "./OfflineView.module.css";

const OfflineView = () => (
  <div id="view_app_loading" className={styles.viewCentered}>
    <ShowitNameLogo />
    <Text variant="heading-1" variant-style="strong">
      {MessageUtils.getErrorExpression()}! Connection lost. <br />
    </Text>
    Please check your Internet connection and refresh your browser.
  </div>
);

export default OfflineView;
